export default __webpack_public_path__ + "static/media/photo--lg--ish-2.95a3e7b7.jpg";